const {ModelTableDatasetConfiguration} = require("./configuration/model-table-dataset-configuration");
const {PreviewTab} = require("../preview-tab/preview-tab");

const ModelTableDatasetStepTabs = {
    configuration: ModelTableDatasetConfiguration,
    preview: PreviewTab,
};
exports.ModelTableDatasetStepTabs = ModelTableDatasetStepTabs;
